import { useCallback, useEffect, useState } from 'react'
import { getTasks } from 'actions/collaborativeTasks'

/**
 * Loads tasks for an application and exposes filter switching + a refetch.
 *
 * Filter values:
 *   'open'      → status=ASSIGNED,REJECTED
 *   'completed' → status=COMPLETED
 *   'all'       → no status filter
 */
const filterToStatusCsv = (filter) => {
    if (filter === 'open') return 'ASSIGNED,REJECTED'
    if (filter === 'completed') return 'COMPLETED'
    return null
}

export const useTasks = (applicationUuid, initialFilter = 'open') => {
    const [filter, setFilter] = useState(initialFilter)
    const [tasks, setTasks] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    const fetchData = useCallback(async () => {
        if (!applicationUuid) return
        setLoading(true)
        setError(null)
        try {
            const res = await getTasks(applicationUuid, filterToStatusCsv(filter))()
            const payload = res?.response || res
            setTasks(Array.isArray(payload) ? payload : [])
        } catch (e) {
            setError(e)
            setTasks([])
        } finally {
            setLoading(false)
        }
    }, [applicationUuid, filter])

    useEffect(() => { fetchData() }, [fetchData])

    return { filter, setFilter, tasks, loading, error, refetch: fetchData }
}
